import { createRoot } from 'react-dom/client';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';

import 'rsuite/dist/rsuite.min.css';

// Get Auth0 configuration from environment variables or use defaults
const auth0Domain = process.env.REACT_APP_AUTH0_DOMAIN || '';
const auth0ClientId = process.env.REACT_APP_AUTH0_CLIENT_ID || '';
const auth0Audience = process.env.REACT_APP_AUTH0_AUDIENCE || '';

const container = document.getElementById('root');
const root = createRoot(container);

// The app uses HashRouter, so post-login navigation must go through the URL
// hash. Normalize whatever returnTo callers passed (e.g. "/jobs", "#/jobs",
// "/#/jobs") into a hash route, strip Auth0's code/state from the query, and
// drive HashRouter via window.location.hash.
const onRedirectCallback = (appState) => {
  const raw = (appState && appState.returnTo) || '/';
  let hashPath;
  if (raw.startsWith('/#/')) {
    hashPath = raw.slice(2);
  } else if (raw.startsWith('#/')) {
    hashPath = raw.slice(1);
  } else if (raw.startsWith('/')) {
    hashPath = raw;
  } else {
    hashPath = `/${raw}`;
  }
  window.history.replaceState({}, document.title, `${window.location.pathname}#${hashPath}`);
  window.location.hash = `#${hashPath}`;
};

if (auth0Domain && auth0ClientId) {
  root.render(
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        audience: auth0Audience || undefined,
        redirect_uri: `${window.location.origin}/`
      }}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      <App />
    </Auth0Provider>
  );
} else {
  // Auth0 not configured, render app without Auth0 provider
  root.render(<App />);
}

